import { Controller, useFormContext } from 'react-hook-form'
import { BirthDate as BirthDateField, checkIsValidDisplayDateNotation, convertDisplayDateToISO } from '@boltenergy-be/design-system'
import { InputProps } from '../types'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useGetLanguage } from 'hooks/use-get-language'

const BirthDate = ({ required, name = 'birthDate', ...props }: Omit<InputProps, 'label'> & { name?: string }) => {
  // React Hook Form
  const { control } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])
  const language = useGetLanguage()

  return (
    <Controller
      {...{ name, control }}
      rules={{
        required: {
          value: !!required,
          message: t(($) => $.required, {
            ns: 'validation'
          })
        },
        validate: {
          valid: (value) => {
            return (!required && !value) || checkIsValidDisplayDateNotation(value as string) || t(($) => $.dateOfBirth.errors.invalid)
          },
          minAge: (date) => {
            if (!date) return true
            const isoDate = convertDisplayDateToISO(date)
            return dayjs(isoDate).isBefore(dayjs().subtract(18, 'years')) || t(($) => $.dateOfBirth.errors.min18)
          },
          maxAge: (date) => {
            if (!date) return true
            const isoDate = convertDisplayDateToISO(date)
            return dayjs(new Date(isoDate)).isAfter(dayjs('1900-01-01')) || t(($) => $.dateOfBirth.errors.maxAge)
          }
        }
      }}
      render={({ field, formState }) => (
        <BirthDateField
          {...props}
          ref={field.ref}
          name={field.name}
          label={t(($) => $.dateOfBirth.label)}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          error={formState?.errors?.[name]?.message as string | undefined}
          {...{ language }}
        />
      )}
    />
  )
}

export default BirthDate
